import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'timeDiff'
})
export class TimeDiffPipe implements PipeTransform {

  transform(started: moment.Moment= null, finished: moment.Moment = null, refresh: any = null): string {
    if(!started) return 'Nicht gestartet';
    if(!finished) return `läuft seit ${moment.duration(moment().diff(started)).asSeconds()}s`;
    return `Abgeschlossen nach ${moment.duration(finished.diff(started)).asSeconds()}s`;
  }

}
